<template>
  <div class="center-cmp">
    <div class="cc-header">
      <dv-decoration-1 style="width:200px;height:50px;" />
      <div>全国物流</div>
      <dv-decoration-1 style="width:200px;height:50px;" />
    </div>

    <div id="map">
      main
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import chinaJson from '/public/map/json/china.json'
export default {
  name: 'CenterCmp',
  props: {
    sendCenter: {
      type: Object || null,
      default: null
    },
    receieveCenter: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      echarts: null,
      geoCoordMap: {
        '兰考': [114.385481, 34.825227],
        '郑州市': [113.4668, 34.6234],
        '开封市': [114.311523, 34.809969]
      },
      moveLine: {
        'normal': [
          { 'fromName': '兰考', 'toName': '郑州市', 'coords': [[110.4737, 24.23037], [121.4608382127075, 30.960803695883435]] },
          { 'fromName': '兰考', 'toName': '开封市', 'coords': [[114.385481, 31.86157], [121.4608382127075, 30.960803695883435]] },
          { 'fromName': '兰考', 'toName': '洛阳市', 'coords': [[124.385481, 42.825227], [121.4608382127075, 30.960803695883435]] }
        ],
        'warning': [

        ]
      },
      origin: [
        {
          name: '郑州市',
          value: 190
        },
        {
          name: '开封市',
          value: 190
        }
      ]
    }
  },
  watch: {
    receieveCenter () {
      this.setOption()
    }
  },
  beforeDestroy () {
    this.echarts && this.echarts.dispose()
  },
  methods: {
    convertData (data) {
      var res = []
      for (var i = 0; i < data.length; i++) {
        var geoCoord = this.geoCoordMap[data[i].name]
        if (geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value)
          })
        }
      }
      return res
    },
    setOption () {
      let option = {
        title: {
          x: 'center',
          textStyle: {
            color: '#fff'
          }
        },
        tooltip: {
          trigger: 'item',
          showDelay: 0,
          transitionDuration: 0.2
        },
        // tooltip: {
        //   trigger: 'item',
        //   formatter: function (params) {
        //     console.log(params.value)
        //     // if (typeof(params.value)[2] == "undefined") {
        //     //     return params.name + ' : ' + params.value;
        //     // } else {
        //     return params.name + ' : ' + params.value[2]
        //     // }
        //   }
        // },
        // legend: {
        //   orient: 'vertical',
        //   y: 'bottom',
        //   x: 'right',
        //   data: ['pm2.5'],
        //   textStyle: {
        //     color: '#fff'
        //   }
        // },
        // visualMap: {
        //   show: false,
        //   min: 0,
        //   max: 500,
        //   left: 'left',
        //   top: 'bottom',
        //   text: ['高', '低'], // 文本，默认为数值文本
        //   calculable: true,
        //   seriesIndex: [1],
        //   inRange: {
        //     // color: ['#9074c3', '#4487d5', '#7e9e8e', '#51a2c2']
        //     // color: ['#3B5077', '#031525'] // 蓝黑
        //     // color: ['#ffc0cb', '#800080'] // 红紫
        //     // color: ['#3C3B3F', '#605C3C'] // 黑绿
        //     // color: ['#0f0c29', '#302b63', '#24243e'] // 黑紫黑
        //     // color: ['#23074d', '#cc5333'] // 紫红
        //     // color: ['#00467F', '#A5CC82'] // 蓝绿
        //     // color: ['#1488CC', '#2B32B2'] // 浅蓝
        //     // color: ['#00467F', '#A5CC82'] // 蓝绿
        //
        //   }
        // },

        geo: {
          show: true,
          map: 'china',
          label: {
            normal: {
              show: false
            },
            emphasis: {
              show: false
            }
          },
          roam: true,
          itemStyle: {
            normal: {
              areaColor: 'transparent',
              borderColor: '#3fdaff',
              borderWidth: 2,
              shadowColor: 'rgba(63, 218, 255, 0.5)',
              shadowBlur: 30
            },
            emphasis: {
              areaColor: '#2B91B7'
            }
          }
        },
        series: [

          // {
          //   name: '物流',
          //   type: 'map',
          //   map: 'china',
          //   geoIndex: 0,
          //   aspectScale: 0.75, // 长宽比
          //   showLegendSymbol: false, // 存在legend时显示
          //   label: {
          //     normal: {
          //       show: true
          //     },
          //     emphasis: {
          //       show: false,
          //       textStyle: {
          //         color: '#fff'
          //       }
          //     }
          //   },
          //   roam: true,
          //   itemStyle: {
          //     normal: {
          //       areaColor: '#031525',
          //       borderColor: '#FFFFFF'
          //     },
          //     emphasis: {
          //       areaColor: '#2B91B7'
          //     }
          //   },
          //   animation: false,
          //   data: [
          //     {
          //       name: '安徽',
          //       value: 1000
          //     }
          //   ]
          // }
          //
          // {
          //   name: '城市',
          //   type: 'effectScatter',
          //   coordinateSystem: 'geo',
          //   zlevel: 1,
          //   showEffectOn: 'render',
          //   rippleEffect: {
          //     scale: 3,
          //     brushType: 'stroke'
          //   },
          //   hoverAnimation: true, // 鼠标移上去显示数据
          //   label: {
          //     normal: {
          //       show: true,
          //       position: 'right',
          //       formatter: '{b}'
          //     },
          //     emphasis: {
          //       show: true
          //     }
          //   },
          //   symbolSize: function (val) {
          //     return val[2] / 10
          //   },
          //   itemStyle: {
          //     normal: {
          //       color: '#F4E925',
          //       shadowBlur: 10,
          //       shadowColor: '#05C3F9'
          //     }
          //   },
          //   data: this.convertData(this.origin)
          // },
          //
          // 射线样式 花了一个箭头
          // {
          //   name: '线路',
          //   type: 'lines',
          //   coordinateSystem: 'geo',
          //   zlevel: 2, // 数值越大越在上面
          //   large: true,
          //   symbol: ['none', 'arrow'],
          //   effect: {
          //     show: true,
          //     period: 6,
          //     constantSpeed: 30,
          //     trailLength: 0,
          //     symbolSize: 3 // 圆点大小
          //   },
          //   lineStyle: {
          //     normal: {
          //       // 线条颜色
          //       color: '#0fff17',
          //       opacity: 0.6,
          //       curveness: 0.2
          //     }
          //   },
          //   data: this.moveLine.normal
          // },
          // 射线样式

        ]
      }
      if (this.receieveCenter.length && this.sendCenter) {
        let { lng, lat } = this.sendCenter
        let receieveCenter = this.receieveCenter.map(item => {
          return {
            'coords': [[lng, lat], [item.lng, item.lat]]
          }
        })
        let lineOptions = {
          name: '线路',
          type: 'lines',
          // 通过经纬度定位
          coordinateSystem: 'geo',
          // 相同路径的线 层级高的在上面
          zlevel: 3,
          large: false,
          effect: {
            show: true,
            period: 5, // 动画时长
            trailLength: 0.8, // 特效尾迹的长度
            color: '#fff',
            symbolSize: 4 // 圆点大小
          },
          lineStyle: {
            normal: {
              width: 2,
              // color:'#0fff17',
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#0fff17'
              }, {
                offset: 1,
                color: '#F4E925'
              }], false),
              // 控制曲率
              curveness: 0.2
            }
          },
          data: receieveCenter
        }
        option.series = [...option.series, lineOptions]
        Object.assign(option.geo, { center: [lng, lat], zoom: 1 })
      }
      this.echarts.setOption(option)
    }
  },
  async mounted () {
    this.echarts = echarts.init(document.getElementById('map'))
    try {
      // let res = window.fetch('/map/json/china.json')
      // let r = await res.json()
      // console.log(r)
      echarts.registerMap('china', chinaJson)
      this.setOption()
    } catch (e) {
      console.log(e)
    }
  }
}
</script>

<style lang="less">
#map{
  width: 100%;
  height: 100%;
}
.center-cmp {
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
  display: flex;
  flex-direction: column;

  .cc-header {
    height: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 30px;
  }

  .cc-details {
    height: 120px;
    display: flex;
    justify-content: center;
    font-size: 32px;
    align-items: center;

    .card {
      background-color: rgba(4,49,128,.6);
      color: #08e5ff;
      height: 70px;
      width: 70px;
      font-size: 45px;
      font-weight: bold;
      line-height: 70px;
      text-align: center;
      margin: 10px;
    }
  }

  .cc-main-container {
    position: relative;
    flex: 1;
    display: flex;

    .ccmc-middle {
      width: 50%;
      height: 90%;

      .active-ring-name {
        font-size: 20px !important;
      }
    }

    .ccmc-left, .ccmc-right {
      width: 25%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-size: 24px;

      span {
        font-size: 40px;
        font-weight: bold;
      }

      .station-info {
        height: 80px;
        display: flex;
        align-items: center;
      }
    }

    .ccmc-left {
      align-items: flex-end;

      span {
        margin-left: 20px;
      }
    }

    .ccmc-right {
      align-items: flex-start;

      span {
        margin-right: 20px;
      }
    }
  }

  .label-tag {
    position: absolute;
    width: 500px;
    height: 30px;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
